/**
 * World 1 — "Verdant Forest" (Nature, levels 1–10): Book One, The Purple Egg. Its chapters,
 * battles and pages are built from `story/book-1-the-purple-egg.md` (the single source of truth,
 * `story/README.md`), never authored here. Only the book's FINAL chapters play; its draft chapters
 * stand in the Tale as sealed pages. Levels/caps are stamped from World 1's band at module load by
 * campaignConfig.ts, ramped over the book's planned battles (`plannedBattles`).
 */

import { GORLY, type CampaignWorld } from './builders.js';
import { BOOK_1, BOOK_1_DRAFT_CHAPTERS, BOOK_1_ZONES } from './books/index.js';
import { WORLD_STORIES } from '../campaignStories.js';

export const WORLD_1: CampaignWorld = {
  worldId: BOOK_1.worldId,
  name: 'Verdant Forest',
  element: 'Nature',
  featuredSpeciesId: GORLY,
  story: WORLD_STORIES['w1'],
  locked: false,
  zones: BOOK_1_ZONES,
  plannedBattles: BOOK_1.plannedBattles,
  draftChapters: BOOK_1_DRAFT_CHAPTERS,
};
